import { UseFormReturn } from 'react-hook-form'
import VerificationStepEntity from '../dto/VerificationStepEntity.interface'
import UserEntity from '../dto/UserEntity.interface'
import configStore from '../stores/config.store'

const setSavedPersonalInformation = (
  methods: UseFormReturn<VerificationStepEntity, any>,
  userInfo: UserEntity | undefined
): void => {
  if (userInfo?.verificationSteps?.personalInfo) {
    const personalInfo = userInfo.verificationSteps.personalInfo
    personalInfo.firstName &&
      methods.setValue('personalInfo.firstName', personalInfo.firstName)
    personalInfo.middleName &&
      methods.setValue('personalInfo.middleName', personalInfo.middleName)
    personalInfo.lastName &&
      methods.setValue('personalInfo.lastName', personalInfo.lastName)
    personalInfo.dateOfBirth &&
      methods.setValue('personalInfo.dateOfBirth', personalInfo.dateOfBirth)
    personalInfo.nationality &&
      methods.setValue('personalInfo.nationality', personalInfo.nationality)
    personalInfo.address &&
      methods.setValue('personalInfo.address', personalInfo.address)
  }
}

const setSavedQuestionnaireInformation = (
  methods: UseFormReturn<VerificationStepEntity, any>,
  userInfo: UserEntity | undefined
): void => {
  if (userInfo?.verificationSteps?.questionnaire) {
    const questionnaire = userInfo.verificationSteps.questionnaire
    methods.setValue('questionnaire', questionnaire)
  }
}

const resetQuestionnaireInformation = (
  methods: UseFormReturn<VerificationStepEntity, any>
): void => {
  methods.resetField('questionnaire.intendedUseOfAssets', { defaultValue: '' })
  methods.resetField('questionnaire.branche', { defaultValue: '' })
  methods.resetField('questionnaire.sourceOfFunds', { defaultValue: '' })
  methods.resetField('questionnaire.sourceOfFundsDescription', {
    defaultValue: ''
  })
  methods.resetField('questionnaire.sourceOfWealth', { defaultValue: '' })
  methods.resetField('questionnaire.totalWealth', { defaultValue: '' })
  methods.resetField('questionnaire.annualIncome', { defaultValue: '' })
  methods.resetField('questionnaire.occupation', { defaultValue: '' })
  methods.resetField('questionnaire.sourceOfFundsEvidence', {
    defaultValue: ''
  })
}

interface Option {
  label: string
  value: string
}

const formatQuestionnaireNumber = (
    options: Option[]
): Option[] => {
  return options.map(({ label, value }) => {
    const formattedLabel = label.replace(/\d+/g, (match) => {
        const seperator = configStore.config?.verificationStepsConfig?.questionnaire?.thousandSeperator;
        return String(match).replace(/\B(?=(\d{3})+(?!\d))/g, seperator || '\'');
    })
    return { label: formattedLabel, value }
  })
}

export {
  setSavedPersonalInformation,
  setSavedQuestionnaireInformation,
  resetQuestionnaireInformation,
  formatQuestionnaireNumber
}
